export const UAT_ENV = true; // For Production: Change it to false

export const LOYALTY_URL = "https://mykare.cloud/Rewardz";
export const TOCOM_URL = "https://tocom.cloud";
export const CLOUD_TELEPHONY_URL = "https://mykare.cloud/ACD";
export const HRMS_URL = "https://mykare.cloud/HRMS";

export const PLAN_URL = "https://stage-acd.tocom.cloud/acd_api";

// For Submitting form information
// For UAT
// export const LEADS_DATA_COLLECTOR_URL =
// "https://uat-trust.myfidelity.in/GenericLeadsDataCollector";

// For Prod
export const LEADS_DATA_COLLECTOR_URL =
  "https://web.myfidelity.in/GenericLeadsDataCollector";
